import { Routes } from '@angular/router';
import { AuthPagesGuardService } from '../auth/auth-pages-guard.service';
import { DoctorPaymentGuard } from '../auth/doctor-payment.guard';

export const FULL_ROUTES: Routes = [
  { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },

  // Errores Forbidden y pantallas predeterminadas
  {
    path: '',
    loadChildren: () => import('../../utility-pages/utility-pages.module').then(m => m.UtilityPagesModule)
  },

  {
    path: 'app',
    children: [
      // ✅ 1. RUTA DE PLANES DE PAGO (MOVIDA AQUÍ DENTRO DE 'app')
      // Al estar aquí, la URL será /app/payment-plans, que es a donde apunta el Guard.
      // NO lleva canActivateChild: [DoctorPaymentGuard] para que sea accesible aunque no haya pagado.
      {
        path: 'payment-plans',
        loadChildren: () => import('../../payment-plans/payment-plans.module').then(m => m.PaymentPlansModule),
      },


      // ✅ NUEVA: Ruta de confirmación de pago (sin guard)
      {
        path: 'payment-success',
        loadChildren: () => import('../../payment-success/payment-success.module').then(m => m.PaymentSuccessModule),
      },

      {
        path: 'dashboard',
        loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Cuentas
      {
        path: 'accounts',
        loadChildren: () => import('../../accounts/accounts.module').then(m => m.AccountsModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Doctores
      {
        path: 'doctors',
        loadChildren: () => import('../../doctors/doctors.module').then(m => m.DoctorsModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Profile
      {
        path: 'profile',
        loadChildren: () => import('../../profiles/profiles.module').then(m => m.ProfilesModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Agenda
      {
        path: 'schedule',
        loadChildren: () => import('../../schedule/schedule.module').then(m => m.ScheduleModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Asistentes
      {
        path: 'assistants',
        loadChildren: () => import('../../assistants/assistants.module').then(m => m.AssistantsModule),
      },

      // Pacientes
      {
        path: 'patients',
        loadChildren: () => import('../../patients/patients.module').then(m => m.PatientsModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Consultas
      {
        path: 'consultations',
        loadChildren: () => import('../../consultations/consultations.module').then(m => m.ConsultationsModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Prescripciones
      {
        path: 'prescriptions',
        loadChildren: () => import('../../prescriptions/prescriptions.module').then(m => m.PrescriptionsModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Especialidades medicas
      {
        path: 'medical-specialities',
        loadChildren: () => import('../../medical-specialities/medical-specialities.module').then(m => m.MedicalSpecialitiesModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Estudios medicos
      {
        path: 'medical-studies',
        loadChildren: () => import('../../medical-studies/medical-studies.module').then(m => m.MedicalStudiesModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Seguros medicos
      {
        path: 'insurances',
        loadChildren: () => import('../../medical-insurances/medical-insurances.module').then(m => m.MedicalInsurancesModule),
      },

      // Usuarios en plataforma
      {
        path: 'users',
        loadChildren: () => import('../../users/users.module').then(m => m.UsersModule),
      },

      // Validaciones de admin
      {
        path: 'validations',
        loadChildren: () => import('../../validations/validations.module').then(m => m.ValidationsModule),
      },

      // System Configurations
      {
        path: 'system-configurations',
        loadChildren: () => import('../../system-configurations/system-configurations.module').then(m => m.SystemConfigurationsModule),
      },

      // Measurements Units
      {
        path: 'measurements',
        loadChildren: () => import('../../measurements/measurements.module').then(m => m.MeasurementsModule),
      },

      // Medicines
      {
        path: 'medicines',
        loadChildren: () => import('../../medicines/medicines.module').then(m => m.MedicinesModule),
      },

      // Laboratories
      {
        path: 'laboratories',
        loadChildren: () => import('../../laboratories/laboratories.module').then(m => m.LaboratoriesModule),
      },

      // Diagnoses
      {
        path: 'diagnoses',
        loadChildren: () => import('../../diagnoses/diagnoses.module').then(m => m.DiagnosesModule),
      },

      // Medical Records
      {
        path: 'medical-records',
        loadChildren: () => import('../../medical-records/medical-records.module').then(m => m.MedicalRecordsModule),
      },

      // User Validations
      {
        path: 'user-validation',
        loadChildren: () => import('../../user-validation/user-validation.module').then(m => m.UserValidationModule),
      },

      // Billing
      {
        path: 'billing',
        loadChildren: () => import('../../billing/billing.module').then(m => m.BillingModule),
      },

      // Transcriptions
      {
        path: 'transcriptions',
        loadChildren: () => import('../../transcriptions/transcriptions.module').then(m => m.TranscriptionsModule),
      },

      // diagnostic-center
      {
        path: 'diagnostic-center',
        loadChildren: () => import('../../diagnostic-center/diagnostic-center.module').then(m => m.DiagnosticCenterModule),
      },

      // laboratorio_protesis
      {
        path: 'laboratorio-protesis',
        loadChildren: () => import('../../laboratorio-protesis/laboratorio-protesis.module').then(m => m.LaboratorioProtesisModule),
      },

      // solicit_credit
      {
        path: 'solicit-credit',
        loadChildren: () => import('../../solicit-credit/solicit-credit.module').then(m => m.SolicitCreditModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // solicitud_protesis
      {
        path: 'solicitud-protesis',
        loadChildren: () => import('../../solicitud-protesis/solicitud-protesis.module').then(m => m.SolicitudProtesisModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // consultas
      {
        path: 'consultas',
        loadChildren: () => import('../../consultas/consulta.module').then(m => m.ConsultasModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // pagopar_transactions
      {
        path: 'pagopar-transactions',
        loadChildren: () => import('../../pagopar-transactions/pagopar-transaction.module').then(m => m.PagoparTransactionsModule),
      },

      // banks
      {
        path: 'banks',
        loadChildren: () => import('../../banks/banks.module').then(m => m.BanksModule),
      },

      // plan_doctors
      {
        path: 'plan-doctors',
        loadChildren: () => import('../../plan-doctors/plan-doctors.module').then(m => m.PlanDoctorsModule),
      },

      // presupuestos
      {
        path: 'presupuestos',
        loadChildren: () => import('../../presupuestos/presupuestos.module').then(m => m.PresupuestosModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // doctor_bank_account
      {
        path: 'doctor-bank-account',
        loadChildren: () => import("../../doctor-bank-account/doctor-bank-account.module").then(m => m.doctorBankAccountModule),
        canActivateChild: [DoctorPaymentGuard]
      },

      // Plans
      {
        path: 'plans',
        loadChildren: () => import('../../plans/plans.module').then(m => m.PlansModule),
      },

      // Notifications
      {
        path: 'notifications',
        loadChildren: () => import('../../notifications/notifications.module').then(m => m.NotificationsModule),
      },

      // Reporting
      {
        path: 'reports',
        loadChildren: () => import('../../reports/reports.module').then(m => m.ReportsModule),
      },

      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      }
    ],
    canActivateChild: [AuthPagesGuardService]
  }
];